// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c5f68727","455":"6575cce3","488":"13c583fb","977":"c1528a18"}[chunkId] + ".chunk.js";
};